import styled from "@emotion/styled";
import { Map } from "react-feather";
import { isActiveType, StyledPropsWithTheme } from "../../utils/globalTypes";

const PreflightLogo = styled(Map)<StyledPropsWithTheme<isActiveType>>`
  color: ${({ theme, isActive }) =>
    isActive ? "#fff" : theme.palette.text.secondary};
`;
export const Styled = { PreflightLogo };
